import styled, { keyframes, css } from 'styled-components';
var propbarFadeTransition = keyframes(["0%{opacity:1;z-index:3;}27%{opacity:1;z-index:3;}33%{opacity:0;z-index:1;}94%{opacity:0;z-index:1;}100%{opacity:1;z-index:3;}"]);
var Container = styled.div.withConfig({
  displayName: "Propbarstyles__Container",
  componentId: "wudkwy-0"
})(["position:relative;padding:0;line-height:normal;border-bottom:1px solid ", ";display:flex;justify-content:center;align-items:stretch;min-width:", ";@media (min-width:", "){height:40px;}"], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].xs;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
var BlockLink = styled.a.withConfig({
  displayName: "Propbarstyles__BlockLink",
  componentId: "wudkwy-1"
})(["text-decoration:none;span{text-decoration:underline;}"]);
var Slot = styled.a.withConfig({
  displayName: "Propbarstyles__Slot",
  componentId: "wudkwy-2"
})(["display:flex;align-items:center;justify-content:center;text-decoration:none;margin:0;height:58px;width:100%;padding:15px 0;background-color:", ";position:absolute;top:0;animation:", " 12s infinite;&:nth-child(1){animation-delay:0s;opacity:1;z-index:3;}&:nth-child(2){animation-delay:4s;opacity:1;z-index:2;}&:nth-child(3){animation-delay:8s;opacity:1;z-index:1;}&:focus{z-index:4;opacity:1;animation:none;}@media (min-width:", "){z-index:1;opacity:1;flex:1 1 0px;position:relative;animation:none;&:nth-child(2){margin:0 10px;}}"], function (props) {
  return props.theme.color.monochrome.light;
}, propbarFadeTransition, function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
var IconWrapper = styled.div.withConfig({
  displayName: "Propbarstyles__IconWrapper",
  componentId: "wudkwy-3"
})(["display:flex;align-items:center;svg{height:30px;width:35px;", "}"], function (props) {
  return css(["", " ", " ", ""], props.fastTrackIcon && css(["&:nth-child(1){height:22px;width:45px;margin-right:8px;}&:nth-child(2){fill:#494c4a;padding-right:8px;}"]), props.clickAndCollectIcon && css(["height:27px;width:59px;margin-top:5px;"]), props.paymentIcon && css(["fill:#494c4a;width:30px;"]));
});
var TextBlock = styled.div.withConfig({
  displayName: "Propbarstyles__TextBlock",
  componentId: "wudkwy-4"
})(["justify-content:center;align-self:stretch;margin-left:8px;padding-left:8px;display:flex;flex-direction:column;align-items:stretch;font-size:0.75rem;border-left:1px solid ", ";p{line-height:normal;margin:0;}"], function (props) {
  return props.theme.color.monochrome.base;
});
var Strong = styled.strong.withConfig({
  displayName: "Propbarstyles__Strong",
  componentId: "wudkwy-5"
})(["", ""], function (props) {
  return css(["", ""], props.mauve ? css(["color:#781f74;"]) : css(["color:", ";"], props.theme.color.monochrome.darker));
});
var Icon = styled.span.withConfig({
  displayName: "Propbarstyles__Icon",
  componentId: "wudkwy-6"
})(["svg,img{vertical-align:middle;margin-right:8px;}img{margin-bottom:3px;}@media (min-width:", "){svg{margin-right:10px;}}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
var Wrapper = styled.ul.withConfig({
  displayName: "Propbarstyles__Wrapper",
  componentId: "wudkwy-7"
})(["", " li{display:none;align-items:center;justify-content:center;}li:first-child{display:flex;}", " @media (min-width:", "){display:flex;justify-content:center;li{display:flex;flex-basis:33.33%;}li:first-child{border-right:1px solid ", ";}li:last-child{border-left:1px solid ", ";}}"], function (props) {
  return css(["max-width:", ";margin:0 auto;width:100%;padding:8px 0;"], props.theme.size.breakpoint['min-width'].xl);
}, function (props) {
  return css(["", ""], props.brand === 'habitat' && css(["li{svg{margin-bottom:2px;}}"]));
}, function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.color.monochrome.light;
});
var PropbarLink = styled.a.withConfig({
  displayName: "Propbarstyles__PropbarLink",
  componentId: "wudkwy-8"
})(["", ""], function (props) {
  return css(["font-size:", ";&:hover{text-decoration:underline;}"], props.theme.font.size.base);
});
export { Container, Strong, Slot, IconWrapper, TextBlock, BlockLink, Wrapper, PropbarLink, Icon };